import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from 'src/app/services/alert.service';
import { ApiService } from 'src/app/services/api.service';
import { FileUploadModalService } from 'src/app/services/file-upload-modal.service';
import { UtilService } from 'src/app/services/util.service';
import { FileUploadModalComponent } from '../file-upload-modal/file-upload-modal.component';
import { HttpEventType } from '@angular/common/http';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-retry-file-upload',
    templateUrl: './retry-file-upload.component.html',
    styleUrls: ['./retry-file-upload.component.scss'],
    imports: [NgStyle]
})
export class RetryFileUploadComponent {
  // Add these properties
selectedFile: File | null = null;
uploadProgress: number = 0;
uploadError: string | null = null;

isFileUploading: boolean = false;
isFileUploaded: boolean = false;

file:any;

constructor(
  private readonly as: AlertService,
  public dialogRef: MatDialogRef<FileUploadModalComponent>,
  @Inject(MAT_DIALOG_DATA) public data: any, private api:ApiService, public util:UtilService, private ref: ChangeDetectorRef) { 
    this.file = data;
}

// Update the uploadFiles method to handle a single file
uploadFiles(event: any) {
  const files = event.target.files;
  if (!files || files.length === 0) return;
  this.selectedFile = files[0];
  // Reset progress and error when a new file is selected
  this.uploadProgress = 0;
  this.uploadError = null;
}

// Format bytes utility function 
formatBytes(bytes: number, decimals: number = 2): string {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

// Update the upload method
upload() {
  if (!this.selectedFile) {
    this.as.toast("Please select a file to upload");
    return;
  }
  
  this.isFileUploading = true;
  this.isFileUploaded = false;
  this.uploadProgress = 0;
  this.uploadError = null;
  
  // Add retry flag to the data
  const uploadData = {
    ...this.file, 
    isRetry: true
  };

  this.api.uploadFile(this.selectedFile, uploadData).subscribe(
    (event: any) => {
      if (event.type === HttpEventType.UploadProgress) {
        this.uploadProgress = Math.round((100 * event.loaded) / event.total);
      } else if (event.type === HttpEventType.Response) {
        this.isFileUploading = false;
        this.isFileUploaded = true;
        this.uploadProgress = 100;
        this.as.toast('File uploaded successfully');
      }
    },
    (err: any) => {
      this.isFileUploading = false;
      this.uploadError = err.statusText ? err.statusText : "Could not upload file";
      this.as.toast('File upload failed: ' + (err.statusText || "Unknown error"));
    }
  );
}
  
}
